module.exports = __webpack_public_path__ + "img/main-favicon.b89ea3c2.png";